function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  d: "M7.58668 1.34595C7.09543 1.80369 6.70142 2.3557 6.42814 2.96903C6.15486 3.58236 6.00791 4.24444 5.99607 4.9158C5.98422 5.58715 6.10772 6.25401 6.35919 6.8766C6.61067 7.49919 6.98496 8.06474 7.45975 8.53954C7.93455 9.01433 8.50011 9.38863 9.12269 9.6401C9.74528 9.89157 10.4121 10.0151 11.0835 10.0032C11.7548 9.99138 12.4169 9.84443 13.0303 9.57115C13.6436 9.29787 14.1956 8.90386 14.6533 8.41261C14.4413 11.9026 11.544 14.6666 8.00068 14.6666C4.31801 14.6666 1.33334 11.6819 1.33334 7.99995C1.33334 4.45661 4.09734 1.55928 7.58668 1.34595Z",
  fill: "black"
});

var SvgMoonFill = function SvgMoonFill(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgMoonFill, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/moon-fill.60779714.svg";
export { ForwardRef as ReactComponent };